import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-59924fe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "public-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "public-page__atmosphere",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = { class: "public-page__content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Dream Client",
  class: "public-page__logo",
  src: _imports_0
}, null, -1))
const _hoisted_5 = { class: "public-page__panel bg-light rounded" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "public-page__code" }, "404", -1))
const _hoisted_7 = { class: "public-page__title" }
const _hoisted_8 = { class: "public-page__text" }
const _hoisted_9 = { class: "public-page__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: { name: 'home' },
        class: "public-page__logo-link"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.t('notFound.title')), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.t('notFound.text')), 1),
        _createVNode(_component_router_link, {
          class: "button button--primary",
          to: {name: 'home'}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('notFound.cta')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", _hoisted_9, "Dream Client © 2019–" + _toDisplayString(_ctx.year), 1)
    ])
  ]))
}